import axios from "axios";
import LocalStorage from "../localStorage";
import {loggedOut} from "./auth";

export const GET_VIEW_REQUEST = 'GET_VIEW_REQUEST';
export const GET_VIEW_SUCCESS = 'GET_VIEW_SUCCESS';
export const GET_VIEW_FAILURE = 'GET_VIEW_FAILURE';

const localStorageService = LocalStorage.getService();

export const getViewRequest = () => {
    return {type: GET_VIEW_REQUEST}
};

export const getViewSuccess = (view = {}) => {
    return {type: GET_VIEW_SUCCESS, view}
};

export const getViewFailure = (error) => {
    return {type: GET_VIEW_FAILURE, error}
};

export const startGetView = () => {
    console.log('Start startGetView');
    let token = localStorageService.getAccessToken();
    return (dispatch) => {
        dispatch(getViewRequest());
        return axios({
                url: `${process.env.REACT_APP_API_ROOTURL}/view/list?key=${process.env.REACT_APP_SERVICE_ACCOUNT_KEY}`,
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': '*',
                    Authorization: 'Bearer ' + token,
                },
                data: JSON.stringify({}),
            }
        )
            .then(function (response) {
                if (response.status === 200 && response.data !== null) {
                    console.log("Response view search ", response.data);
                    dispatch(getViewSuccess(response.data));

                }
            })
            .catch(function (error) {
                console.log(error);
                if(error.response.status === 401) dispatch(loggedOut());
                dispatch(getViewFailure(error));
            });
    };
};
